// Omgevingen, eigen thema en agendaverbindingen (Turks). Zelfde vorm als omgevingApp.nl.ts.
export const appOmgevingTr = {
    spaces: {
        mine: 'Benim alanım',
        switchLabel: 'Alan değiştir',
        choose: 'Alan seç',
        private: 'Özel',
        shared: 'Ortak',
        dialogTitle: 'Alanını seç',
        dialogBody: 'Kendin için ya da başkalarıyla birlikte planla.',
        close: 'Kapat',
        current: 'Şu anki alan',
        privateHint: 'Özel · yalnızca senin için',
        sharedHint: 'Ortak · birlikte planla',
        opening: 'Alan açılıyor…',
        failed: 'Değiştirme olmadı. Lütfen tekrar dene.',
        personalNotice: 'Benim alanım · özel: bu plan ve veriler yalnızca senin için. Birlikte planlamak için yukarıdan Ortak alana geç.',
    },
    personalTheme: {
        title: 'Temam',
        body: 'Uygulamanın görünümünü seç. Bu seçim hesabında saklanır ve tüm cihazlarında geçerlidir. Ortak pano ve diğer kullanıcılar kendi temalarını korur.',
        auto: 'Hanemin temasını izle',
        warm: 'Sıcak ve neşeli',
        calm: 'Yumuşak ve sakin',
        minimal: 'Sade',
        graphic: 'Net ve grafik',
        contrast: 'Büyük ve yüksek kontrastlı',
        failed: 'Teman yüklenemedi.',
        retry: 'Tekrar dene',
        saved: 'Teman kaydedildi.',
    },
    calendarSync: {
        title: 'Takvim bağlantılarım',
        intro: 'Birincil Google veya Microsoft takvimini {name} ile bağla. Bu bağlantıyı yalnızca sen yönetirsin. Bu alanda içe aktarılan randevular için normal erişim hakları geçerlidir.',
        details: 'Her beş dakikada bir otomatik olarak, 30 gün öncesinden bir yıl sonrasına kadar. Tekrarlanan randevular ayrı randevular olarak eşitlenir. Yalnızca başlık, saatler, konum ve notlar paylaşılır; katılımcılar veya davetler paylaşılmaz. Katılımcılı toplantıları Google veya Outlook içinde düzenle.',
        connected: 'Takvim bağlandı. Hemen başlamak için Şimdi eşitle’yi seç.',
        failed: 'Bağlantı kurulamadı ya da iptal edildi. Tekrar dene.',
        retry: 'Tekrar dene',
        provider: 'Takvim hizmeti',
        google: 'Google Takvim / Gmail',
        googleShort: 'Google Takvim',
        microsoft: 'Microsoft 365 / Outlook',
        direction: 'Eşitleme yönü',
        import: 'Yalnızca AMUMIN’e',
        export: 'Yalnızca AMUMIN’den',
        both: 'İki yönlü',
        scope: 'Hangi randevular gönderilsin?',
        scopeMine: 'Katıldığım randevular',
        scopeAll: 'Bu alandaki tüm randevular',
        notConfigured: 'Bu takvim hizmetinin önce AMUMIN tarafından etkinleştirilmesi gerekiyor. Mevcut takvim abonelikleri kullanılmaya devam eder.',
        alreadyConnected: 'Zaten bağlı',
        connect: 'Takvimi bağla',
        lastSync: 'Son eşitleme: {when}',
        neverSynced: 'Henüz eşitlenmedi',
        conflicts: {
            one: '{count} randevu iki tarafta da değiştirildi veya silindi. Saklandı. İki takvimi de kontrol et ve hangi sürümü tutacağını seç.',
            other: '{count} randevu iki tarafta da değiştirildi veya silindi. Saklandılar. İki takvimi de kontrol et ve hangi sürümü tutacağını seç.',
        },
        synced: 'Eşitleme tamamlandı.',
        syncNow: 'Şimdi eşitle',
        keepLocal: 'AMUMIN sürümlerini tut',
        keepRemote: 'Dış sürümleri tut',
        disconnect: 'Bağlantıyı durdur',
        disconnectHint: 'Durdurmak hiçbir randevuyu silmez. Yönü değiştirmek için bağlantıyı durdur ve yeniden bağlan.',
        personalLinks: 'Kişisel takvimin özel kalır. Ortak abonelik bağlantılarını ortak alanından oluşturursun.',
    },
    errors: {
        personalSpacePrivate: 'Kişisel alanın yalnızca senin için. Kişileri davet etmek veya bir pano bağlamak için Ortak alana geç.',
        providerNotConfigured: 'Bu takvim hizmeti henüz AMUMIN tarafından etkinleştirilmedi.',
        alreadyConnected: 'Bu takvim hizmeti zaten bağlı. Yeniden bağlanmak için önce mevcut bağlantıyı durdur.',
    },
    rideOpen: {
        dropoff: '{title} için {names} kimle gidiyor?',
        dropoffNoNames: '{title} için kim götürüyor?',
        pickup: '{title} sonrası {names} kimle dönüyor?',
        pickupNoNames: '{title} sonrası kim alıyor?',
    },
    notMeHint: '{link}: e-postanın altındaki bağlantıyı kullan.',
    ingredientsPlaceholder: '500 g kıyma\n1 soğan\n1 kutu domates',
};
//# sourceMappingURL=omgevingApp.tr.js.map